module.exports = __webpack_public_path__ + "static/media/logo_oficial2018.898f55e2.png";